import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

export default function Dashboard() {
  const [user, setUser] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      localStorage.setItem('token', token);
      window.history.replaceState({}, '', '/dashboard');
    }

    const storedToken = localStorage.getItem('token');
    if (!storedToken) {
      navigate('/');
      return;
    }

    fetch('/api/auth/me', {
      headers: { Authorization: `Bearer ${storedToken}` }
    })
      .then(r => r.json())
      .then(data => {
        if (data.email) setUser(data);
        else navigate('/');
      })
      .catch(() => navigate('/'));
  }, [navigate]);

  if (!user) return (
    <div className="flex justify-center items-center h-64">
      <div className="text-gray-500">Loading...</div>
    </div>
  );

  return (
    <div className="max-w-6xl mx-auto px-4 py-10">
      <div className="bg-white rounded-xl shadow-sm border p-6 mb-8">
        <h1 className="text-2xl font-bold text-gray-800">
          Welcome, {user.name} 👋
        </h1>
        <p className="text-gray-500 mt-1">{user.email}</p>
        <span className="inline-block mt-2 bg-blue-100 text-blue-700 text-xs px-3 py-1 rounded-full font-semibold uppercase">
          {user.plan} Plan
        </span>
      </div>

      <h2 className="text-xl font-semibold text-gray-700 mb-4">Quick Access</h2>
      <div className="grid md:grid-cols-2 gap-4">
        <Link to="/tools/capital-gain"
          className="bg-white rounded-xl border p-6 hover:border-blue-300 hover:shadow-md transition group">
          <div className="text-3xl mb-3">📈</div>
          <h3 className="font-semibold text-gray-800 group-hover:text-blue-700">
            Capital Gain Calculator
          </h3>
          <p className="text-sm text-gray-500 mt-1">
            Upload broker PDF and get tax report
          </p>
        </Link>
        <Link to="/tools/tds-calculator"
          className="bg-white rounded-xl border p-6 hover:border-blue-300 hover:shadow-md transition group">
          <div className="text-3xl mb-3">🧮</div>
          <h3 className="font-semibold text-gray-800 group-hover:text-blue-700">
            TDS Calculator
          </h3>
          <p className="text-sm text-gray-500 mt-1">
            Find TDS section and rate using AI
          </p>
        </Link>
      </div>
    </div>
  );
}
